import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-209427c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-[25px] tw-w-full tw-relative actions" }
const _hoisted_2 = { class: "tw-text-xs tw-text-[12px] tw-font-semibold tw-leading-[100%] tw-tracking-[1.2px] tw-uppercase actions-header" }
const _hoisted_3 = ["id", "data-cy", "onClick"]
const _hoisted_4 = { class: "tw-w-[34px] tw-h-[34px] tw-flex tw-items-center tw-justify-center tw-rounded-[50%] icon_wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_CustomDropDown = _resolveComponent("CustomDropDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getUiText("app-settings-action-menu-title-1")), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileActions, (action, index) => {
      return (_openBlock(), _createElementBlock("div", {
        id: 
        action.title === 'app-settings-team-roles-more-modal-delete-role-1' &&
        !_ctx.onUpdateAction
          ? `'popover-action-button-${_ctx.member?.length}'`
          : action.id
            ? `${action.id}`
            : ''
      ,
        key: index,
        "data-cy": action.title,
        class: _normalizeClass(`tw-flex tw-w-full tw-justify-between tw-items-center tw-cursor-pointer action ${action.class}`),
        onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDeleteRole && _ctx.onDeleteRole(...args))),
        onClick: ($event: any) => (_ctx.handleActionClick(action))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(`tw-flex tw-items-center tw-flex-1 tw-text-[15px] tw-font-medium tw-leading-[100%] tw-gap-[10px] title_wrapper  ${
          _ctx.member?.length === 0 && action.icon.__name === 'deleteIcon'
            ? 'disable'
            : ''
        } ${
          _ctx.member?.length > 0 && action.icon.__name === 'deleteIcon'
            ? 'disable'
            : ''
        } ${
          !_ctx.disable &&
          _ctx.member?.length === 0 &&
          action.icon.__name === 'deleteIcon'
            ? 'remove'
            : ''
        }`)
        }, [
          _createElementVNode("span", _hoisted_4, [
            (typeof action.icon === 'string')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: action.icon,
                  alt: "reset_password",
                  class: "tw-h-[16px] tw-w-[16px] icon"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon), {
                  key: 1,
                  color: action.iconColor,
                  class: "tw-h-[18px] tw-w-[18px]"
                }, null, 8, ["color"]))
          ]),
          _createElementVNode("span", {
            class: _normalizeClass(`tw-flex-1 tw-text-[15px] ${action.titleClass}`)
          }, _toDisplayString(_ctx.getUiText(action.title)), 3)
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(`right-arrow
         ${
           _ctx.member?.length > 0 && action.icon.__name === 'deleteIcon'
             ? 'disable'
             : ''
         } ${
           _ctx.member?.length === 0 && action.icon.__name === 'deleteIcon'
             ? 'remove'
             : ''
         }  ${
           _ctx.member?.length === 0 &&
           action.icon.__name === 'deleteIcon' &&
           _ctx.disable
             ? 'demo'
             : ''
         }`)
        }, [
          _createVNode(_component_ArrowRightIcon)
        ], 2)
      ], 42, _hoisted_3))
    }), 128)),
    (_ctx.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_CustomDropDown, {
            "id-popover": `'popover-action-button-${_ctx.member?.length}'`,
            "custom-class": "red-tooltip"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.getUiText(
                "app-settings-team-roles-manage-role-bulk-actions-delete-role-warning-1",
              )), 1)
            ]),
            _: 1
          }, 8, ["id-popover"])
        ]))
      : _createCommentVNode("", true)
  ]))
}